import { sleepFrames } from '../c-mp/fun/sleepFrames'

export async function onLinkClickFocusSearchInput() {
	await sleepFrames(2)
	document.getElementById('tceq7c')?.focus()
}
